// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { ReadSchElementObjectArgs_abstract } from './../../abstract/SagaBase/Defines/ReadSchElementObjectArgs_abstract';
export class ReadSchElementObjectArgs extends ReadSchElementObjectArgs_abstract {}
